export default "__VITE_ASSET__DM0Y$pck__"